<script setup>
import { computed, defineEmits, defineExpose, ref } from 'vue';
import util from '@/util';
import service from '@/service';
import { CONTEXT } from '@/const';
import PrivacyAndUserAgreeDialog from '@/component/PrivacyAndUserAgreeDialog'

const emit = defineEmits(['confirm']);

const visible = ref(false);
const countryCode = ref('');

const privacyAndUserAgreeVisible = ref(false);
const privacyAndUserAgreeContentType = ref('');

const usePrivacyStatement = () => {
  const privacyName = ref('');
  const siteId = ref();
  const tenantId = ref();
  // 判断国别码是否在中国大陆
  const isCN = computed(() => '+86' === countryCode.value.split(' ')[0]);
  const showSecond = computed(() => {
    const checkSiteId = siteId.value === '11';
    const checkTenantId = [5, '11111111111111111111111111111111'].includes(tenantId.value);
    return isCN.value && checkSiteId && checkTenantId;
  });

  const calling = async () => {
    const res = await service.getPrivacyStatement();
    privacyName.value = res.name;
    siteId.value = res.siteId;
    tenantId.value = res.tenantId;
  };

  calling();

  return { privacyName, showSecond };
};
const { privacyName, showSecond } = usePrivacyStatement();

const useUserAgreement = () => {
  const userAgreementName = ref('');

  const calling = async () => {
    const { name } = await service.getUserAgreement();
    userAgreementName.value = name;
  };

  calling();

  return { userAgreementName };
};
const { userAgreementName } = useUserAgreement();

const openPrivacyAndUserAgreeDialog = (type)=>{
  privacyAndUserAgreeVisible.value = true;
  privacyAndUserAgreeContentType.value = type;
};

const open = val => {
  visible.value = true;
  countryCode.value = val;
};

defineExpose({
  open,
});
</script>

<template>
  <van-dialog
    v-model="visible"
    :title="$t('dialog.userAgreements.header')"
    show-cancel-button
    :confirm-button-text="$t('dialog.agreeButton')"
    :cancel-button-text="$t('dialog.disagreeButton')"
    @confirm="emit('confirm')"
    get-container="body"
  >
    <div class="content text-sm" :class="{ 'text-center': !showSecond }">
      <div>
        <template v-if="showSecond">{{ '1. ' }}</template>
        <i18n path="dialog.userAgreements.text1">
          <span class="link cursor-pointer" place="privacy" @click="openPrivacyAndUserAgreeDialog('privacyStatement')">
            {{ privacyName }}
          </span>
          <span class="link cursor-pointer" place="agreement" @click="openPrivacyAndUserAgreeDialog('userAgreement')">
            {{ userAgreementName }}
          </span>
        </i18n>
      </div>
      <div v-if="showSecond">
        2.
        <i18n path="dialog.userAgreements.text2">
          <span class="link cursor-pointer" place="privacy" @click="openPrivacyAndUserAgreeDialog('privacyStatement')">
            {{ privacyName }}
          </span>
        </i18n>
      </div>
    </div>
    <privacy-and-user-agree-dialog 
      :dialogVisible="privacyAndUserAgreeVisible" 
      :type="privacyAndUserAgreeContentType"
      @onClose="privacyAndUserAgreeVisible=false"/>
  </van-dialog>
</template>

<style scoped>
.content {
  color: #595959;
}

.link {
  color: #0067d1;
}
</style>
